import registry from "@patternslib/patternslib/src/core/registry";
import "./js/jsalerts.pattern";

registry.init();
